export enum CLUSTER_NAME {
  PROD = 'prod',
  STAGING = 'staging',
  UAT = 'uat',
  DEV = 'dev',
  LOCAL = 'local',
}

export const ENVIRONMENT_NAMES = {
  PROD: 'prod',
  DEV: 'dev',
  UAT: 'uat',
  STAGING: 'staging',
  LOCAL: 'local',
}

export enum MICRO_SERVICES {
  DASH = 1,
  DESK = 2,
  API = 3,
  DAEMON = 4,
  DRIVA_TYPES = 5,
  SALESFORCE = 6,
  PARTNERS = 7,
  SERVICE_LAYER = 8,
  VEHICLES_API = 9,
  REFERRAL = 10,
  TRACKING = 11,
}
